import { useTranslation } from '@mc/i18n'
import { Locations, Product, NavigationEvents } from '@mc/track-event'
import Link from 'components/Link'
import { trackNavigationClick } from 'components/Navigation/events'
import { homePath } from 'libs/paths'

export const MasterClassLink = ({
  className = '',
  location = Locations.NAVIGATION,
  product = Product.MASTERCLASS,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
  product?: (typeof Product)[keyof typeof Product]
}) => {
  const { t } = useTranslation('@mc/next')

  const ctaCopy = t('nav.cta.masterClass')

  const handleMasterClassClick = () => {
    trackNavigationClick(
      ctaCopy,
      NavigationEvents.LEVELS.PRIMARY,
      location,
      product,
    )
  }

  return (
    <Link
      href={homePath()}
      className={className}
      onClick={handleMasterClassClick}
      passHref
      newTab
    >
      {ctaCopy}
    </Link>
  )
}
